//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateMatrizPagos } from "@/typings/store/plugins/easyFirestore/matrizPagos";

const getters: GetterTree<StateMatrizPagos, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const matrizPagos = {
    firestorePath: "dev/v1/matrizPagos",
    firestoreRefType: "collection",
    moduleName: "matrizPagos",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default matrizPagos;
